import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import userAxios from '../../axios/user'

export const fetchUser = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchUserStart())

    // const { role_id, is_active, is_ldap } = filterOptions
    // const checkexist = () => {
    //   return is_active === 0 || is_ldap === 0 ? true : is_active || is_ldap || role_id
    // }

    // let api = checkexist() ? '/search' : ''
    userAxios
      .get('search', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data
          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchUserSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchUserFailed(error))
      })
  }
}

export const fetchUserStart = () => {
  return {
    type: actionTypes.FETCH_USER_START
  }
}

export const fetchUserSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_USER_SUCCESS,
    pagination,
    records
  }
}

export const fetchUserFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_USER_FAILED,
    errorMessage
  }
}

export const fetchUserById = recordId => {
  return dispatch => {
    dispatch(fetchUserStart())
    userAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchUserByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUserFailed(error))
      })
  }
}

export const fetchUserByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_USER_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedUserRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_USER_RECORD
  }
}

export const createUser = (recordData, page) => {
  return dispatch => {
    dispatch(createUserStart())

    userAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(createUserSuccess())
          dispatch(fetchUser(page))
          dispatch(
            enqueueSnackbar({
              message: 'User Created',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid User field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createUserFailed())
      })
  }
}

export const createUserStart = () => {
  return {
    type: actionTypes.CREATE_USER_START
  }
}

export const createUserSuccess = () => {
  return {
    type: actionTypes.CREATE_USER_SUCCESS
  }
}

export const createUserFailed = () => {
  return {
    type: actionTypes.CREATE_USER_FAILED
  }
}

export const updateUser = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateUserStart())

    userAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(updateUserSuccess())
        dispatch(
          enqueueSnackbar({
            message: 'User Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(fetchUser(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid User field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateUserFailed())
      })
  }
}

export const updateUserStart = () => {
  return {
    type: actionTypes.UPDATE_USER_START
  }
}

export const updateUserSuccess = () => {
  return {
    type: actionTypes.UPDATE_USER_SUCCESS
  }
}

export const updateUserFailed = () => {
  return {
    type: actionTypes.UPDATE_USER_FAILED
  }
}

export const deleteUser = (recordId, page) => {
  return dispatch => {
    dispatch(deleteUserStart())
    userAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(deleteUserSuccess())
        dispatch(fetchUser(page))
        dispatch(
          enqueueSnackbar({
            message: 'User Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteUserFailed())
      })
  }
}

export const deleteUserStart = () => {
  return {
    type: actionTypes.DELETE_USER_START
  }
}

export const deleteUserSuccess = message => {
  return {
    type: actionTypes.DELETE_USER_SUCCESS,
    message
  }
}

export const deleteUserFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_USER_FAILED,
    errorMessage
  }
}

export const fetchUserFilter = filter => {
  return dispatch => {
    dispatch(fetchUserFilterStart())
    userAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchUserFilterSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUserFilterFailed(error))
      })
  }
}

export const fetchUserFilterStart = () => {
  return {
    type: actionTypes.FETCH_USER_FILTER_START
  }
}

export const fetchUserFilterSuccess = data => {
  return {
    type: actionTypes.FETCH_USER_FILTER_SUCCESS,
    data
  }
}

export const fetchUserFilterFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_USER_FILTER_FAILED,
    errorMessage
  }
}

export const fetchUserRoleOption = () => {
  return dispatch => {
    dispatch(fetchUserRoleOptionStart())
    userAxios
      .get('/role/dropdown',)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchUserRoleOptionSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchUserRoleOptionFailed(error))
      })
  }
}

export const fetchUserRoleOptionStart = () => {
  return {
    type: actionTypes.FETCH_USER_ROLE_OPTION_START
  }
}

export const fetchUserRoleOptionSuccess = data => {
  return {
    type: actionTypes.FETCH_USER_ROLE_OPTION_SUCCESS,
    data
  }
}

export const fetchUserRoleOptionFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_USER_ROLE_OPTION_FAILED,
    errorMessage
  }
}
